module.exports = __webpack_public_path__ + "img/scratch_image_atari.fde1ed63.png";